/*
 * View for the topic label modal
 */

define([
  "jquery",
  "marionette",
  "modules/admin/userAdministration/userDetails/touchpointMapDisplay/template/touchpointMapTemplate.html",
], function ($, Marionette, TouchpointMapTemplate) {
  "use strict";

  const TouchpointMapView = {};

  TouchpointMapView.touchpointMapView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: TouchpointMapTemplate,
    events: {
      "click .chkTouchpoint": function (e) {
        //get the intent id of the topic by getting the custom data attribute
        const touchpointId = $(e.target).attr("data-touchpointId");
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:touchpoint", touchpointId);
      },
    },
  });

  return TouchpointMapView;
});
